import { render, staticRenderFns } from "./P32DayVatReport.vue?vue&type=template&id=6fc6d644&"
import script from "./P32DayVatReport.vue?vue&type=script&lang=js&"
export * from "./P32DayVatReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports